import * as React from 'react';
import StatusIndicatorProps from './StatusIndicatorProps.interface';
import { capitalizeFirstLetterEachWord } from '../..';
import './status-indicator.scss';

// eslint-disable-next-line arrow-body-style
const StatusIndicator = ({ status } : StatusIndicatorProps): JSX.Element => {
  const statusClass = `status-${status.toString().toLowerCase()}`;

  if (!status) {
    return (<></>);
  }

  return (
    <div className="statusIndicator">
      <div className={`statusIndicatorStatus ${statusClass}`}>
        {capitalizeFirstLetterEachWord(status.toString().replace('_', ' '))}
      </div>
    </div>
  );
};

export default StatusIndicator;
